module.exports = __webpack_public_path__ + "static/media/blue-pin.1c915e32.png";